/* Sovamia — garde-fou des cadeaux à 0 $ (18/10/2026).
   Un cadeau (pyjama, taies, guides, cartes, livre de motifs) ne vaut 0 $ qu'avec son produit payant.
   Si la cliente retire le produit payant, ou ajoute plus de cadeaux que son achat n'en donne,
   les cadeaux en trop sont retirés du panier. Une page de cadeau ouverte seule renvoie au produit payant. */
(() => {
  // g : variantes cadeau · p : poids par variante payante (v) ou par produit (P) · max : plafond par commande
  const R = [
    { g: [59520891060572, 59520891093340], v: { 59520889356636: 1, 59520889389404: 1,
        59520889422172: 2, 59520889454940: 2, 59520889487708: 2 } },          // pyjama ← ceinture chauffante
    { g: [59342089650524], P: { 15863656153436: 2 } },                          // 2 taies par douillette
    { g: [59407455813980], P: { 15875095888220: 1 }, max: 1 },                  // guide anti-taches ← lave-casquette
    { g: [59407455846748], P: { 15875095888220: 1 }, max: 1 },                  // guide d'entretien ← lave-casquette
    { g: [59447486316892], P: { 15881263219036: 1 } },                          // cartes émotions ← livre ourson
    { g: [59524222353756], P: { 15894593601884: 1 }, max: 1 }                   // livre de motifs ← Ravaudo
  ];
  const PAGES = { "ensemble-pyjama-douillet-cadeau": "ceinture-chauffante-sovamia",
    "taies-oreiller-offertes": "douillette-4-saisons-2-en-1", "guide-anti-taches": "lave-casquette",
    "guide-entretien": "lave-casquette", "cartes-emotions-cadeau-ourson": "livre-activites-montessori-mon-ourson",
    "livre-motifs-numerique-ravaudo": "ravaudo-kit-de-reprisage" };
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const m = location.pathname.match(/\/products\/([^/?#]+)/);
  if (m && PAGES[m[1]]) { location.replace(root + "products/" + PAGES[m[1]]); return; }

  const F = window.fetch.bind(window);
  let busy = false;
  async function guard() {
    if (busy) return; busy = true;
    try {
      const cart = await F(root + "cart.js").then((r) => r.json());
      const upd = {};
      for (const r of R) {
        let ok = 0;
        for (const i of cart.items) {
          if (r.v && r.v[i.variant_id]) ok += r.v[i.variant_id] * i.quantity;
          else if (r.P && r.P[i.product_id] && !r.g.includes(i.variant_id)) ok += r.P[i.product_id] * i.quantity;
        }
        if (r.max != null) ok = Math.min(ok, r.max);
        const lines = cart.items.filter((i) => r.g.includes(i.variant_id));
        let extra = lines.reduce((a, i) => a + i.quantity, 0) - ok;
        for (let k = lines.length - 1; k >= 0 && extra > 0; k--) {
          const l = lines[k], take = Math.min(extra, l.quantity);
          upd[l.key] = l.quantity - take; extra -= take;
        }
      }
      if (Object.keys(upd).length) {
        await F(root + "cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: upd }) });
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
        const dr = document.querySelector("cart-drawer");
        if (dr && dr.getSectionsToRender && dr.renderContents) {
          const ids = dr.getSectionsToRender().map((s) => s.id);
          const sections = await F(location.pathname + "?sections=" + ids.join(",")).then((r) => r.json());
          dr.renderContents({ sections });
        }
      }
    } catch (e) {} finally { busy = false; }
  }
  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : (input && input.url) || "";
    const p = F(input, init);
    if (!busy && /\/cart\/(change|update|add)(\.js)?/.test(url)) p.then(() => setTimeout(guard, 150));
    return p;
  };
  if (document.readyState !== "loading") guard(); else document.addEventListener("DOMContentLoaded", guard);
})();
